export const SET_ANALYTICS_LOGGING_ENABLED = 'setAnalyticsLoggingEnabled';
export const SET_PUBNUB_LOGGING_ENABLED = 'setPubnubLoggingEnabled';
